import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ReactToPrint from 'react-to-print';
import { useDispatch, useSelector } from "react-redux";
import { useGotoLogin } from 'hooks/useGotoLogin';

import ListItems from "./ListItems";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import AddItemDropdown from "./AddItemDropdown";
import {
  addOrAddAllProductToCart,
  productMarkUncompleted,
  getCartList,
  productMarkCompleteAll,
} from "redux/actions";
import "./customlist-items.scss";
import { getLocalStorageValue } from 'config/helper';
import loader from "assets/images/loader.gif";
import { useGetListDetails } from 'hooks/useGetListDetails';

const ItemList = () => {
  const dispatch = useDispatch();
  const gotoLogin = useGotoLogin();
  const componentRef = useRef();
  const { id } = useParams();
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const clientId = getLocalStorageValue("RSAclient-id");

  const { currentStoreID } = useSelector(({ store }) => store);

  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");

  const { customerListDetails, customerListName, ListLoading } = useGetListDetails();
  const {
    ecom_section: { allow_ecommerce = "" },
    header_section: { allow_ecom_cart_and_checkout = "" },
  } = useSelector(({ common }) => common.commonDetailsData);

  const breadcrumbList = [{ lable: "List Items", link: "" }];

  const [unCompletedItem, setUncompletedItem] = useState([]);
  const [completedItem, setCompletedItem] = useState([]);
  const mealKitUncompletedItemsAvailable = unCompletedItem?.some(item => +item.is_mealkit > 0);

  useEffect(() => {
    const completed = [], uncompleted = []

    customerListDetails.forEach(item => {
      if (item.is_complete === "1") {
        completed.push(item)
      } else if (item.is_complete === "0") {
        uncompleted.push(item)
      }
    })

    setUncompletedItem(uncompleted)
    setCompletedItem(completed)
  }, [customerListDetails]);

  const handleAddAllItemToCart = () => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      list_id: id,
      items_data: unCompletedItem.map((product) => {
        return { product_id: product.product_id, qty: product.qty };
      }),
    };
    isUserLoggedIn &&
      dispatch(addOrAddAllProductToCart(body)).then((res) => {
        const body = {
          RSAClientId: clientId,
          ClientStoreId: +storeId || 1,
          AppName: "shop",
          member_number: memberNumber,
          user_token: userToken,
          Version: "1",
          DeviceType: "web",
        };
        isUserLoggedIn && dispatch(getCartList(body));
      });
  };

  const handleClickUncompleteAll = () => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      list_id: id,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      items_data: completedItem.map((product) => {
        return { product_id: product.product_id, qty: product.qty };
      }),
    };
    dispatch(productMarkUncompleted(body));
  };

  const handleClickCompleteAll = () => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      list_id: id,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      items_data: unCompletedItem.map((product) => {
        return { product_id: product.product_id };
      }),
    };
    dispatch(productMarkCompleteAll(body));
  };

  return (
    <>
      <div style={{ display: "none" }}>
        <Print listName={customerListName} data={customerListDetails} ref={componentRef} />
      </div>

      <BreadcrumbDetailed breadcrumbList={breadcrumbList} title={`List Items`} />

      <div className="container">
        <div className="custom-list-cart-section-align">
          <div className="cart-title">
            <h1>{customerListName && customerListName}</h1>
          </div>
          <div className="page-grid-align">
            {!ListLoading && customerListName ? (
              <div>
                <p>
                  There are {customerListDetails && customerListDetails.length}
                  {!customerListDetails && "0"} products in your list
                </p>
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img style={{ width: '100px', height: '50px' }} src={loader} />
                <span>Loading, please wait....</span>
              </div>
            )}
            <div className="action-buttons">
              <div className="download-button">
                <ReactToPrint
                  trigger={() => <button type="submit" >
                    <i className="fa-solid fa-print"></i>
                    <span>Print and Download</span>
                  </button>}
                  content={() => componentRef.current}
                />
              </div>

              <AddItemDropdown />

              {unCompletedItem && unCompletedItem.length === 0 ? (
                <div className="add-list-button">
                  <button onClick={handleClickUncompleteAll}>
                    <span>Uncomplete All</span>
                  </button>
                </div>
              ) : (
                <div className="add-list-button">
                  <button onClick={handleClickCompleteAll}>
                    <span>Complete all items</span>
                  </button>
                </div>
              )}
              {allow_ecommerce === "1" && allow_ecom_cart_and_checkout === "1" && !mealKitUncompletedItemsAvailable && (
                <div className="add-list-button">
                  <button onClick={handleAddAllItemToCart}>
                    <span>Add all Items to cart</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="custom-list-cart-section">
          <div className="cart-grid">
            <div className="cart-grid-items">
              <ListItems list_id={id} customerListDetails={unCompletedItem} setProductList={setUncompletedItem}  />
            </div>
          </div>
        </div>
      </div>
      <div className="container your-cart-section-align">
        <div className="sub-cart-title">
          <h1>Completed Items</h1>
        </div>
      </div>
      <div className="container">
        <div className="custom-list-cart-section">
          <div className="cart-grid">
            <div className="cart-grid-items">
              <ListItems
                list_id={id}
                isCompletedGrid={true}
                customerListDetails={completedItem}
                setProductList={setCompletedItem}
              />
            </div>
          </div>
        </div>
      </div>

    </>
  );
};


const Print = React.forwardRef(({ listName, data }, ref) => {
  return (
    <div ref={ref} className="list-product-table">
      <h1>{listName}</h1>
      <table>
        <thead>
          <tr className="list-title">
            <th>Product</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Department</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => (
            <tr key={item.product_id}>
              <td>{item.name}</td>
              <td>{item.qty}</td>
              <td>{item.price}</td>
              <td>{item.department_name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
})

export default ItemList;
